export default __webpack_public_path__ + "static/media/Resume5-page-001.9e039f16.jpg";